export default "__VITE_ASSET__C6t8vwcv__"